import React, { Component } from 'react';
// import { StopWatchIcon } from '../../shared/icons';
import FieldInfo from '../../shared/FieldInfo';
import  StopWatchIcon  from '../../_styles/images/Time.png';


function DailyTripTimeInfo() {
  return (
    <div>
      <p>Daily Trip Details is a required field for Trip Recording that should have accurate drive times and mileage for each day</p>
    </div>
  );
}
export default function() {
    return (
      <div className="driveTimeDuration" role='group'>
        {/* <StopWatchIcon className="stopwatch" aria-label='daily trip icon'/> */}
        <img src={StopWatchIcon} className="stopwatch"  />
      <div className="driveTimeHeading" aria-label='Daily Trip Details'>Daily Trip Details</div>
      <FieldInfo  aria-label='info icon' message={<DailyTripTimeInfo />} />

      </div>
    );
}